/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { IconWithContentCardContent } from '../Shared/IconWithContentCardContent'

const NoCheckoutSystemCardContent = () => {
    const [t] = useTranslation()

    return (
      <IconWithContentCardContent
        iconElement={(
          <>
              <Icon color="grey" name="plug"/>
              <Icon corner name="ban" color="grey"/>
          </>
        )}
        contentElement={(
          <p
            css={css`
                margin-right: .5rem;
                font-weight: bold;
            `}>
              {t('dashboard.checkout_system.no_checkout_system_connected')}
          </p>
        )}
      />
    )
}

export { NoCheckoutSystemCardContent }
